/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Tab_LoginInputs */



/**
* | output |
* | --- |
* | "Login" |
*
* @param {Login_Tab_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_tab_login = /** @type {((inputs?: Login_Tab_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Tab_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar sesión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entrar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi")
	return /** @type {LocalizedString} */ ("Login")
});